var _path, _path2, _path3, _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusybed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.2857C13 19.0233 14.0233 18 15.2857 18H15.5455C18.5579 18 21 20.4421 21 23.4545C21 23.7558 20.7558 24 20.4545 24H13.7826C13.3504 24 13 23.6496 13 23.2174V20.2857Z",
    fill: "#1DAFED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40 26.344v-0.0103h-27.315v-9.8593c0-0.814-0.5823-1.4739-1.3005-1.4739h-0.084c-0.7182 0-1.3005 0.6599-1.3005 1.4739v16.176h2.685v-3.2736h24.63v3.2967h2.685v-6.3294z",
    fill: "#168af5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39 21.578c0-1.1859-0.9745-2.1471-2.1764-2.1471l-11.647-1.4313c-1.2019 0-2.1764 0.9612-2.1764 2.147v2.853c0 0.5523 0.4477 1 1 1h14c0.5523 0 1-0.4477 1-1v-1.4216z",
    fill: "#168af5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5,
    cy: 24,
    rx: 8.5,
    ry: 8,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_17697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.384 29.994c3.4926 0 6.3842-2.7223 6.3842-5.9971 0-3.2808-2.8979-5.9971-6.3905-5.9971-3.4862 0-6.3779 2.7163-6.3779 5.9971 0 3.2748 2.8979 5.9971 6.3842 5.9971z",
    fill: "#168af5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.378 29.1c-1.4333 0-2.8854-0.5527-3.843-1.511 0.6759-0.9995 2.1468-1.5875 3.843-1.5875 1.6837 0 3.1671 0.5762 3.8493 1.5875-0.9639 0.9583-2.4097 1.511-3.8493 1.511zm0-4.098c-1.2017-0.0118-2.1468-0.9525-2.1468-2.2165-0.0063-1.1877 0.9513-2.1754 2.1468-2.1754 1.2018 0 2.1469 0.9877 2.1469 2.1754 0 1.264-0.9389 2.2283-2.1469 2.2165z",
    fill: "#fff",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_17697"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(12 18)",
    width: 13,
    height: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusybed);
export default __webpack_public_path__ + "static/media/Busybed.2072db3f481491541daabab9226a09fe.svg";
export { ForwardRef as ReactComponent };